import {AfterViewChecked, AfterViewInit, Directive, ElementRef, HostListener, Input} from "@angular/core";

@Directive({
  selector: '[vbRatioWidth]'
})
export class RatioWidthDirective implements AfterViewInit, AfterViewChecked {

  @Input('vbRatioWidth')
  ratio: number = 1.0;

  private height: number;

  @HostListener('window:resize')
  onResize() {
    this.setHeight();
  }

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setHeight();
    });
  }

  ngAfterViewChecked() {
    this.setHeight();
  }

  computeHeight(): number {
    if (this.el.nativeElement.clientWidth) {
      return (this.el.nativeElement.clientWidth * this.ratio);
    } else {
      return this.el.nativeElement.clientHeight;
    }
  }

  setHeight() {
    let h = this.computeHeight();
    this.applyHeightToElement(h);
  }

  private applyHeightToElement(height: number) {
    if (this.el.nativeElement.clientWidth && this.el.nativeElement.clientWidth > 0) {
      if (this.height !== height) {
        this.height = height;
        this.el.nativeElement.style.height = this.height + "px";
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/directives/ratio-width.directive.ts